import { AUTH_METHOD_HTTP_BASIC } from "./sourceTypeConfig";

export const getSourceTypeFormatName = (type) => String(type || "AUTO").toUpperCase();

export const formatBoolLabel = (value, { trueLabel = "SI", falseLabel = "NO", nullLabel = "AUTO" } = {}) => {
  if (value == null) {
    return nullLabel;
  }
  return value ? trueLabel : falseLabel;
};

export const formatGdriveLabel = (value) => {
  if (value === true) {
    return "SI";
  }
  if (value === false) {
    return "NO";
  }
  return "NO";
};

export const formatDetectionLabel = (value) => (
  value === "manual" ? "MANUALE" : "AUTOMATICO"
);

export const formatAuthMethodLabel = (auth, authMethod) => {
  if (!auth) {
    return "—";
  }
  return authMethod || AUTH_METHOD_HTTP_BASIC;
};

export const getSourceTypeFormatLabel = getSourceTypeFormatName;

export const buildSourceTypeSummaryFields = (config) => {
  const parsed = config || {};
  return [
    { key: "type", label: "FORMATO", value: getSourceTypeFormatName(parsed.type), showFormatLegend: true },
    { key: "is_headless", label: "Headless", value: formatBoolLabel(parsed.is_headless, { nullLabel: "NO" }) },
    { key: "detection", label: "Detection", value: formatDetectionLabel(parsed.detection) },
    { key: "auth", label: "Autenticato", value: formatBoolLabel(parsed.auth, { nullLabel: "NO" }) },
    { key: "auth_method", label: "Metodo auth", value: formatAuthMethodLabel(parsed.auth, parsed.auth_method) },
    { key: "gdrive", label: "Google Drive", value: formatGdriveLabel(parsed.gdrive) },
  ];
};
